import { render, staticRenderFns } from "./account-verification-modal.vue?vue&type=template&id=42fa511a&"
import script from "./account-verification-modal.vue?vue&type=script&lang=ts&"
export * from "./account-verification-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports